import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useMemo, useContext, useState } from 'react';
import { View, Text, TouchableOpacity, Linking } from 'react-native';
import { cdnFile } from '@mkt-common/shopee-common';
import { useLocale } from '../../LocaleProvider/rn';
import { ButtonGroup } from '../../ButtonGroup/rn';
import { Button } from '../../Button/rn';
import { Popup } from '../../Popup/rn';
import CopySVG from '../../../assets/images/rn/Copy';
import ContactCourierCallSVG from '../../../assets/images/rn/ContactCourierCall';
import { ConfigContext } from '../../ConfigProvider/rn/context';
import { ButtonEvents } from '../../../types';
import { CONTACT_COURIER_CARD } from '../../../utils/constants';
import { Image } from '../../Image/rn';
import Styles, { GenerateStyles } from './styles';
import { useComponentTracking } from '../../../hooks/rn/useTracking';
export var ContactInfoEnum;
(function (ContactInfoEnum) {
  ContactInfoEnum["Email"] = "email";
  ContactInfoEnum["WhatsApp"] = "whatsapp";
  ContactInfoEnum["Facebook"] = "facebook";
  ContactInfoEnum["Call"] = "call";
  ContactInfoEnum["Line"] = "line";
})(ContactInfoEnum || (ContactInfoEnum = {}));
export var ActInternalType;
(function (ActInternalType) {
  ActInternalType[ActInternalType["TelcoCall"] = 0] = "TelcoCall";
  ActInternalType[ActInternalType["InternetCall"] = 1] = "InternetCall";
})(ActInternalType || (ActInternalType = {}));
export var ContactCourierCard = function ContactCourierCard(props) {
  var _ContactInfoText, _driverInfo$milestone, _driverInfo$driver_na;
  var trackLinks = props.trackLinks,
    _props$contactsInfo = props.contactsInfo,
    contactsInfo = _props$contactsInfo === void 0 ? [] : _props$contactsInfo,
    _props$driverInfo = props.driverInfo,
    driverInfo = _props$driverInfo === void 0 ? {} : _props$driverInfo,
    logoImg = props.logoImg,
    courierTitle = props.courierTitle,
    orderInfo = props.orderInfo,
    operateTime = props.operateTime,
    handleCopyClick = props.handleCopyClick,
    showDriverInfo = props.showDriverInfo,
    _props$componentTrack = props.componentTrackingData,
    componentTrackingData = _props$componentTrack === void 0 ? {} : _props$componentTrack;
  var _useLocale = useLocale(),
    trans = _useLocale.trans,
    region = _useLocale.region;
  var context = useContext(ConfigContext);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var ContactInfoText = (_ContactInfoText = {}, _defineProperty(_ContactInfoText, ContactInfoEnum.Email, trans(CONTACT_COURIER_CARD.EMAIL)), _defineProperty(_ContactInfoText, ContactInfoEnum.WhatsApp, trans(CONTACT_COURIER_CARD.WHATS_APP)), _defineProperty(_ContactInfoText, ContactInfoEnum.Facebook, trans(CONTACT_COURIER_CARD.FACEBOOK)), _defineProperty(_ContactInfoText, ContactInfoEnum.Call, trans(CONTACT_COURIER_CARD.CALL)), _defineProperty(_ContactInfoText, ContactInfoEnum.Line, trans(CONTACT_COURIER_CARD.LINE) || 'Line'), _ContactInfoText); // const defaultButtonProps: Partial<ButtonProps> = {
  //   type: 'secondary-outlined',
  //   styles: {
  //     containerStyle: Styles['contact-courier-card-content-button-container'],
  //     textStyle: Styles['contact-courier-card-content-button-text'],
  //   },
  // };

  var handleTrack = function handleTrack() {
    if ((trackLinks === null || trackLinks === void 0 ? void 0 : trackLinks.length) === 1) {
      var _context$eventEmitter, _context$eventEmitter2, _trackLinks$;
      context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, ButtonEvents.Redirection, {
        text: '',
        action: {
          url_info: {
            url: trackLinks === null || trackLinks === void 0 ? void 0 : (_trackLinks$ = trackLinks[0]) === null || _trackLinks$ === void 0 ? void 0 : _trackLinks$.url
          }
        }
      });
    } else {
      setActive(true);
    }
  };
  var _useComponentTracking = useComponentTracking(props),
    tracker = _useComponentTracking.tracker,
    _useComponentTracking2 = _useComponentTracking.result,
    ContactCourierCardButton_trackOrder = _useComponentTracking2.ContactCourierCardButton_trackOrder,
    ContactCourierCardCallDriver_driverCall = _useComponentTracking2.ContactCourierCardCallDriver_driverCall,
    ContactCourierCardCopyPaste_copy = _useComponentTracking2.ContactCourierCardCopyPaste_copy;
  var buttons = useMemo(function () {
    var ContactCourierCardButton_call = componentTrackingData.ContactCourierCardButton_call,
      ContactCourierCardButton_facebook = componentTrackingData.ContactCourierCardButton_facebook,
      ContactCourierCardButton_whatsapp = componentTrackingData.ContactCourierCardButton_whatsapp,
      ContactCourierCardButton_email = componentTrackingData.ContactCourierCardButton_email;
    return contactsInfo === null || contactsInfo === void 0 ? void 0 : contactsInfo.map(function (v, i) {
      var trackingData = {};
      if (v.action === ContactInfoEnum.Email) {
        trackingData = ContactCourierCardButton_email;
      } else if (v.action === ContactInfoEnum.Call) {
        trackingData = ContactCourierCardButton_call;
      } else if (v.action === ContactInfoEnum.Facebook) {
        trackingData = ContactCourierCardButton_facebook;
      } else if (v.action === ContactInfoEnum.WhatsApp) {
        trackingData = ContactCourierCardButton_whatsapp;
      }
      var defaultProps = {
        type: 'secondary-outlined',
        styles: {
          containerStyle: GenerateStyles(i)['contact-courier-card-content-button-container'],
          textStyle: Styles['contact-courier-card-content-button-text']
        }
      };
      if (v.action === ContactInfoEnum.Email || v.action === ContactInfoEnum.Call) {
        var _defaultProps$styles;
        var protocol = v.action === ContactInfoEnum.Email ? 'mailto:' : 'tel:';
        return _objectSpread(_objectSpread({}, defaultProps), {}, {
          trackingData: trackingData,
          text: ContactInfoText[v.action],
          children: /*#__PURE__*/React.createElement(TouchableOpacity, {
            onPress: function onPress() {
              if (v.act_internal_type === ActInternalType.InternetCall) {
                if (v !== null && v !== void 0 && v.inhouse_queue_call) {
                  var _context$eventEmitter3, _context$eventEmitter4;
                  context === null || context === void 0 ? void 0 : (_context$eventEmitter3 = context.eventEmitter) === null || _context$eventEmitter3 === void 0 ? void 0 : (_context$eventEmitter4 = _context$eventEmitter3.emit) === null || _context$eventEmitter4 === void 0 ? void 0 : _context$eventEmitter4.call(_context$eventEmitter3, ButtonEvents.InternetCall, {
                    text: ContactInfoText[v.action],
                    data: v === null || v === void 0 ? void 0 : v.inhouse_queue_call
                  });
                } else {
                  var _context$eventEmitter5, _context$eventEmitter6;
                  context === null || context === void 0 ? void 0 : (_context$eventEmitter5 = context.eventEmitter) === null || _context$eventEmitter5 === void 0 ? void 0 : (_context$eventEmitter6 = _context$eventEmitter5.emit) === null || _context$eventEmitter6 === void 0 ? void 0 : _context$eventEmitter6.call(_context$eventEmitter5, ButtonEvents.NoQueueInternetCall, {
                    text: ContactInfoText[v.action]
                  });
                }
              } else {
                Linking.openURL("".concat(protocol).concat(v.information));
              }
            }
          }, /*#__PURE__*/React.createElement(Text, {
            style: [defaultProps === null || defaultProps === void 0 ? void 0 : (_defaultProps$styles = defaultProps.styles) === null || _defaultProps$styles === void 0 ? void 0 : _defaultProps$styles.textStyle, Styles['contact-courier-card-content-button-link']]
          }, ContactInfoText[v.action])) // className: clsx(defaultButtonProps.className, getPrefixCls('contact-courier-card-content-button-link')),
        });
      }

      return _objectSpread(_objectSpread({}, defaultProps), {}, {
        trackingData: trackingData,
        text: ContactInfoText[v.action],
        action: {
          func: ButtonEvents.OpenExternalLink,
          url_info: {
            url: v.information
          }
        }
      });
    });
  }, [contactsInfo, componentTrackingData]);
  return /*#__PURE__*/React.createElement(View, {
    style: Styles['contact-courier-card']
  }, /*#__PURE__*/React.createElement(View, {
    style: Styles['contact-courier-card-header']
  }, logoImg ? /*#__PURE__*/React.createElement(Image, {
    styles: {
      imageStyle: Styles['contact-courier-card-header-pic'],
      containerStyle: Styles['contact-courier-card-header-pic-container']
    },
    src: logoImg.startsWith('https://') || logoImg.startsWith('http://') ? logoImg : "data:image/png;base64, ".concat(logoImg)
  }) : /*#__PURE__*/React.createElement(View, {
    style: Styles['contact-courier-card-header-pic-container']
  }, /*#__PURE__*/React.createElement(View, {
    style: Styles['contact-courier-card-header-pic']
  })), /*#__PURE__*/React.createElement(Text, {
    style: Styles['contact-courier-card-header-title']
  }, courierTitle)), /*#__PURE__*/React.createElement(View, {
    style: Styles['contact-courier-card-content']
  }, /*#__PURE__*/React.createElement(View, {
    style: Styles['contact-courier-card-content-top']
  }, orderInfo !== null && orderInfo !== void 0 && orderInfo.image ? /*#__PURE__*/React.createElement(Image, {
    src: cdnFile(orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.image, region),
    styles: {
      imageStyle: Styles['contact-courier-card-content-top-pic']
    }
  }) : /*#__PURE__*/React.createElement(View, {
    style: Styles['contact-courier-card-content-top-pic']
  }), /*#__PURE__*/React.createElement(View, {
    style: Styles['contact-courier-card-content-top-order']
  }, /*#__PURE__*/React.createElement(View, {
    style: Styles['contact-courier-card-content-top-order-text']
  }, /*#__PURE__*/React.createElement(Text, {
    style: Styles['contact-courier-card-content-top-order-text-copy'],
    numberOfLines: 1,
    ellipsizeMode: "tail"
  }, orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.shipping_trace_no), orderInfo !== null && orderInfo !== void 0 && orderInfo.shipping_trace_no ? /*#__PURE__*/React.createElement(TouchableOpacity, _extends({}, ContactCourierCardCopyPaste_copy === null || ContactCourierCardCopyPaste_copy === void 0 ? void 0 : ContactCourierCardCopyPaste_copy.trackingImpressionProps, {
    style: Styles['contact-courier-card-content-top-order-text-icon'],
    onPress: function onPress() {
      handleCopyClick === null || handleCopyClick === void 0 ? void 0 : handleCopyClick(orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.shipping_trace_no);
      (ContactCourierCardButton_trackOrder === null || ContactCourierCardButton_trackOrder === void 0 ? void 0 : ContactCourierCardButton_trackOrder.trackingClick) && tracker.click(ContactCourierCardButton_trackOrder.trackingClick);
    }
  }), /*#__PURE__*/React.createElement(CopySVG, null)) : null), /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 1,
    style: Styles['contact-courier-card-content-top-order-status']
  }, trans((_driverInfo$milestone = driverInfo === null || driverInfo === void 0 ? void 0 : driverInfo.milestone_key) !== null && _driverInfo$milestone !== void 0 ? _driverInfo$milestone : ' '))), /*#__PURE__*/React.createElement(TouchableOpacity, {
    style: Styles['contact-courier-card-content-top-track'],
    onPress: function onPress() {
      handleTrack();
    }
  }, /*#__PURE__*/React.createElement(Text, {
    style: Styles['contact-courier-card-content-top-track-text']
  }, trans(CONTACT_COURIER_CARD.TRACK_ORDER)))), showDriverInfo && driverInfo !== null && driverInfo !== void 0 && driverInfo.driver_name && driverInfo !== null && driverInfo !== void 0 && driverInfo.driver_phone ? /*#__PURE__*/React.createElement(View, {
    style: Styles['contact-courier-card-content-center']
  }, /*#__PURE__*/React.createElement(View, {
    style: Styles['contact-courier-card-content-center-left']
  }, /*#__PURE__*/React.createElement(Text, {
    style: Styles['contact-courier-card-content-center-left-name']
  }, trans(CONTACT_COURIER_CARD.DRIVER), ": ", (_driverInfo$driver_na = driverInfo === null || driverInfo === void 0 ? void 0 : driverInfo.driver_name) !== null && _driverInfo$driver_na !== void 0 ? _driverInfo$driver_na : ''), /*#__PURE__*/React.createElement(Text, {
    style: Styles['contact-courier-card-content-center-left-tip']
  }, trans(CONTACT_COURIER_CARD.YOU_CAN_CONNECT_DRIVER))), /*#__PURE__*/React.createElement(View, {
    style: Styles['contact-courier-card-content-center-right']
  }, /*#__PURE__*/React.createElement(TouchableOpacity, _extends({}, ContactCourierCardCallDriver_driverCall === null || ContactCourierCardCallDriver_driverCall === void 0 ? void 0 : ContactCourierCardCallDriver_driverCall.trackingImpressionProps, {
    onPress: function onPress() {
      var _driverInfo$driver_ph;
      Linking.openURL("tel:".concat((_driverInfo$driver_ph = driverInfo === null || driverInfo === void 0 ? void 0 : driverInfo.driver_phone) !== null && _driverInfo$driver_ph !== void 0 ? _driverInfo$driver_ph : ''));
      (ContactCourierCardCallDriver_driverCall === null || ContactCourierCardCallDriver_driverCall === void 0 ? void 0 : ContactCourierCardCallDriver_driverCall.trackingClick) && tracker.click(ContactCourierCardCallDriver_driverCall.trackingClick);
    }
  }), /*#__PURE__*/React.createElement(ContactCourierCallSVG, {
    style: Styles['contact-courier-card-content-center-right-call']
  })))) : null, operateTime !== null && operateTime !== void 0 && operateTime.length || contactsInfo !== null && contactsInfo !== void 0 && contactsInfo.length ? /*#__PURE__*/React.createElement(View, {
    style: Styles['contact-courier-card-content-bottom']
  }, contactsInfo !== null && contactsInfo !== void 0 && contactsInfo.length ? /*#__PURE__*/React.createElement(Text, {
    style: Styles['contact-courier-card-content-bottom-text']
  }, trans(CONTACT_COURIER_CARD.CONTACT_COURIER_ANY_QUESTION)) : null, operateTime !== null && operateTime !== void 0 && operateTime.length && contactsInfo !== null && contactsInfo !== void 0 && contactsInfo.length ? /*#__PURE__*/React.createElement(Text, {
    style: Styles['contact-courier-card-content-bottom-text']
  }, trans(CONTACT_COURIER_CARD.OPERATION_HOURS), ":", ' ', operateTime.map(function (v, i) {
    var _v$working_day, _v$working_day2, _v$working_day3, _v$working_hour, _v$working_hour2;
    return "".concat(i !== 0 ? ', ' : '').concat(v === null || v === void 0 ? void 0 : (_v$working_day = v.working_day) === null || _v$working_day === void 0 ? void 0 : _v$working_day.start, " ").concat(v !== null && v !== void 0 && (_v$working_day2 = v.working_day) !== null && _v$working_day2 !== void 0 && _v$working_day2.end ? '- ' + (v === null || v === void 0 ? void 0 : (_v$working_day3 = v.working_day) === null || _v$working_day3 === void 0 ? void 0 : _v$working_day3.end) : '', " (").concat(v === null || v === void 0 ? void 0 : (_v$working_hour = v.working_hour) === null || _v$working_hour === void 0 ? void 0 : _v$working_hour.start, " - ").concat(v === null || v === void 0 ? void 0 : (_v$working_hour2 = v.working_hour) === null || _v$working_hour2 === void 0 ? void 0 : _v$working_hour2.end, ")");
  })) : null) : null, /*#__PURE__*/React.createElement(ButtonGroup, {
    layout: "horizontal",
    styles: Styles['contact-courier-card-content-buttons'],
    buttons: buttons
  })), /*#__PURE__*/React.createElement(Popup, {
    active: active,
    onClose: function onClose() {
      return setActive(false);
    },
    contentStyle: Styles['contact-courier-card-popup-content']
  }, /*#__PURE__*/React.createElement(View, null, trackLinks.map(function (v, i) {
    return /*#__PURE__*/React.createElement(Button, {
      styles: {
        containerStyle: Styles['contact-courier-card-popup-link']
      },
      action: {
        func: ButtonEvents.Redirection,
        url_info: {
          url: v.url
        }
      },
      text: v.url,
      type: "link",
      key: i,
      numberOfLines: 1
    });
  }), /*#__PURE__*/React.createElement(View, {
    style: Styles['contact-courier-card-popup-gap']
  }), /*#__PURE__*/React.createElement(Text, {
    style: Styles['contact-courier-card-popup-cancel'],
    onPress: function onPress() {
      return setActive(false);
    }
  }, trans(CONTACT_COURIER_CARD.CANCEL) || 'Cancel'))));
};